import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "../../../styles/MobileNumberRegister.module.css";

// images
import RegisterMobileNumberImg from "../../../assets/images/register-mobile-number-img.png";
import LegionLogo from "../../../assets/images/legion-logo.png";
import ContactUsModalImage from "../../../assets/images/contact-us-modal-image.png";

// legion
import {
  Flex,
  Button,
  Text,
  Anchor,
  Textfield,
  Modal,
  Image,
  Box,
  Checkbox,
} from "@legion-ui/core";

// hooks
import { useUsernameRegister } from "../../../hooks/useUsernameRegister";
import {
  IconEye,
  IconEyeOff,
  IconLock,
  IconMail,
  IconUser,
} from "@tabler/icons-react";

export const UsernameRegister = () => {
  const { showModal, state, handleForms, handleRegister, handleBackToSignIn } =
    useUsernameRegister();
  const [passwordStatus, setPasswordStatus] = useState("password");

  const togglePassword = () => {
    if (passwordStatus === "password") {
      setPasswordStatus("text");
      return;
    }

    setPasswordStatus("password");
  };

  return (
    <Flex width="100%" height="100%">
      <Modal show={showModal} width="528px">
        <Image
          width="146px"
          src={ContactUsModalImage}
          alt="modal letter image"
          margin="auto"
        />

        <Text
          as="p"
          size="24px"
          color="tertiary900"
          margin="10px 0 8px 0"
          weight="700"
          style={{ textAlign: "center" }}
        >
          Account Registration Success
        </Text>

        <Text
          as="p"
          color="tertiary500"
          margin="0 0 24px 0"
          style={{ textAlign: "center" }}
        >
          Thank you for registering. Please check your email for confirmation
          and sign in with your account.
        </Text>

        <Button block center variant="solid" onClick={handleBackToSignIn}>
          Back to Sign In
        </Button>
      </Modal>

      <Flex
        alignY="center"
        alignX="center"
        padding={["5rem 0", "26px 16px"]}
        width={["", "50%"]}
        className={styles.register__form}
      >
        <Flex
          direction="column"
          style={{ maxWidth: "464px" }}
          mq={{
            padding: {
              md: "2rem 1rem",
            },
          }}
        >
          <Anchor href="/" block>
            <Image
              width="146px"
              margin="0 0 32px 0"
              src={LegionLogo}
              alt="legion logo"
            />
          </Anchor>
          <Text
            as="h3"
            size={["36px", "24px"]}
            weight="700"
            margin="0 0 12px 0"
            color="tertiary900"
          >
            Sign Up
          </Text>
          <Text
            as="p"
            size={["16px", "14px"]}
            weight="400"
            margin="0 0 24px 0"
            color="tertiary500"
          >
            Create and register your account to discover all your needs!
          </Text>

          <Textfield
            label="Full Name"
            placeholder="Type your full name"
            type="text"
            padding="0 0 1.5rem 0"
            status={state.fullNameStatus}
            message={state.fullNameErrorMessage}
            onChange={handleForms("fullName")}
          />

          <Textfield
            label="Username"
            placeholder="Type your username"
            iconLeft={<IconUser size="20" />}
            type="text"
            padding="0 0 1.5rem 0"
            status={state.userNameStatus}
            message={state.userNameErrorMessage}
            onChange={handleForms("userName")}
          />

          <Textfield
            label="Email"
            placeholder="name@mail.com"
            iconLeft={<IconMail size="20" />}
            type="text"
            padding="0 0 1.5rem 0"
            status={state.emailStatus}
            message={state.emailErrorMessage}
            onChange={handleForms("email")}
          />

          <Textfield
            iconLeft={<IconLock size={20} />}
            iconRight={
              passwordStatus === "password" ? (
                <IconEyeOff
                  className={styles.btn__password}
                  onClick={togglePassword}
                  size={20}
                />
              ) : (
                <IconEye
                  className={styles.btn__password}
                  onClick={togglePassword}
                  size={20}
                />
              )
            }
            label="Password"
            placeholder="Type your password"
            padding="0 0 1.5rem 0"
            type={passwordStatus}
            status={state.passwordStatus}
            message={state.passwordErrorMessage}
            onChange={handleForms("password")}
          />

          <Textfield
            iconLeft={<IconLock size={20} />}
            iconRight={
              passwordStatus === "password" ? (
                <IconEyeOff
                  className={styles.btn__password}
                  onClick={togglePassword}
                  size={20}
                />
              ) : (
                <IconEye
                  className={styles.btn__password}
                  onClick={togglePassword}
                  size={20}
                />
              )
            }
            label="Confirm Password"
            placeholder="Re-type your password"
            type={passwordStatus}
            status={state.confirmPasswordStatus}
            message={state.confirmPasswordErrorMessage}
            onChange={handleForms("confirmPassword")}
            padding="0 0 1.5rem 0"
          />

          <Checkbox required label={<>I agree to <Link to='/tnc'>Terms & Condition</Link> and <Link to='/privacy-policy'>Privacy Policy</Link></>} />

          <Button margin="1.5rem 0 0 0" center onClick={handleRegister}>
            Sign Up
          </Button>

          <Box style={{ textAlign: "center" }}>
            <Text margin="2rem 0 2.5rem 0" as="p" color="tertiary500">
              Already have an account?{" "}
              <Anchor
                href="/login/username"
                weight="700"
                color="primary500"
              >
                Sign In
              </Anchor>
            </Text>
            <Text as="p" color="tertiary500">
              &#9432; Have issue, trouble or question about login or register
            </Text>
            <Anchor
              href="/contact-us/username"
              weight="700"
              color="primary500"
            >
              Contact Us
            </Anchor>
          </Box>
        </Flex>
      </Flex>

      <Flex alignX="end" className={styles.register__image} width={["", "50%"]}>
        <Image
          width="auto"
          height="100%"
          src={RegisterMobileNumberImg}
          fit="cover"
          alt="register mobile number as primary key image"
        />
      </Flex>
    </Flex>
  );
};
